<template>
  <div>
    <PageHead title="银行卡号信息管理"></PageHead>
    <div class="query">
      <div class="query-top">
        <!-- 搜索 -->
        <div class="query-top-item">
          <div class="query-top-lable">姓名：</div>
          <a-input
            allowClear
            placeholder="请输入姓名"
            class="w200"
            v-model="queryForm.fullName"
          />
          <div class="query-top-lable" :style="{ marginLeft: '30px' }">
            身份证号：
          </div>
          <a-input
            allowClear
            placeholder="请输入身份证号"
            class="w200"
            v-model="queryForm.idCardNumber"
            @blur="idCardNumberBlur"
          />
          <div class="query-top-lable" :style="{ marginLeft: '30px' }">
            银行卡号：
          </div>
          <a-input
            allowClear
            placeholder="请输入银行卡号"
            class="w200"
            v-model="queryForm.bankCardNumber"
          />
          <a-button
            :style="{ marginLeft: '50px' }"
            type="primary"
            @click="subMit()"
            :loading="bankCardLoading"
          >
            查询</a-button
          >
          <a-button :style="{ marginLeft: '8px' }" @click="cancel()">
            取消
          </a-button>
        </div>
        <!--  新增  批量导入-->
        <div class="mt20 mb20 search-btns">
          <a-button type="primary" icon="plus" @click="add('0')">
            添加</a-button
          >
          <a-button
            type="primary"
            :style="{ marginLeft: '8px' }"
            @click="showModal(1)"
            icon="swap"
          >
            批量导入</a-button
          >
        </div>
        <blank height="10"> </blank>
      </div>
      <blank height="20"> </blank>
      <div class="query-content">
        <!-- 银行卡号列表 -->
        <a-table
          :pagination="false"
          :columns="columns"
          :data-source="bankCardList"
          :loading="bankCardLoading"
          :row-key="(record) => record.id"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + 1 + (paginationParams.page - 1) * 10 }}
          </span>

          <div slot="action" slot-scope="text, record">
            <a-button type="link" class="btn-link" @click="add('1', record)">
              修改
            </a-button>
            <a-divider type="vertical" />
            <a-button
              type="link"
              class="btn-link"
              @click="deleteRow(record.id)"
            >
              删除
            </a-button>
          </div>
        </a-table>
        <!-- 分页器 -->
        <div class="pagination">
          <a-pagination
            :current="paginationParams.page"
            :default-current="paginationParams.page"
            :total="paginationParams.total"
            :pageSize="paginationParams.size"
            @change="pageChange"
          />
        </div>
      </div>
      <!-- 公共底部 -->
      <appfloor></appfloor>

      <!-- 批量操作 弹窗 -->
      <a-modal v-model="visibleBatchImport" title="批量操作" :footer="null">
        <prompts>
          操作步骤
          <span slot="two">
            1. 下载Excel导入模版。 2. 填写信息到Excel模版。 3.
            将填写好信息的Excel回传到系统<blank height="8"> </blank
          ></span>
        </prompts>
        <div class="xlsx">
          <a-icon type="link" />
          银行卡模板.xlsx
        </div>
        <div class="xlsx-btn">
          <a-button
            icon="vertical-align-bottom"
            type="primary"
            @click="downTemplate"
          >
            下载模板</a-button
          >
          <!-- 上传Excel -->
          <a-upload
            name="file"
            :multiple="false"
            :headers="headers"
            action="#"
            :fileList="bfileList"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
            @change="uploading"
          >
            <a-button icon="vertical-align-top" type="primary">
              上传Excel</a-button
            >
          </a-upload>
        </div>
        <blank height="100"> </blank>
      </a-modal>
      <!-- 导入失败 弹窗 -->
      <a-modal
        v-model="importData"
        title="导入失败"
        @ok="importDataOk"
        :width="600"
      >
        <div class="import-scrollY">
          <div
            class="import-formCont"
            v-for="(i, index) in importList"
            :key="index"
          >
            {{ i }}
          </div>
        </div>
      </a-modal>

      <!-- 新增 / 编辑弹窗 -->
      <a-modal
        v-model="visibleAddEdit"
        :title="addEditTitle"
        @ok="handleAddEditOk"
        :width="500"
        :confirm-loading="confirmLoading"
      >
        <div class="item-formCont">
          <span class="leftTitle">姓名:</span>
          <a-input
            class="w300 ml10"
            placeholder="请输入姓名:"
            v-model="addEditParams.fullName"
          />
        </div>
        <blank height="20"> </blank>
        <div class="item-formCont">
          <span class="leftTitle">身份证号:</span>
          <a-input
            allowClear
            class="w300 ml10"
            placeholder="请输入身份证号:"
            v-model="addEditParams.idCardNumber"
          />
        </div>
        <blank height="20"> </blank>
        <div class="item-formCont">
          <span class="leftTitle">银行卡号:</span>
          <a-input
            allowClear
            class="w300 ml10"
            placeholder="请输入银行卡号:"
            v-model="addEditParams.bankCardNumber"
          />
        </div>
        <blank height="20"> </blank>
        <div class="item-formCont">
          <span class="leftTitle">开户行名称:</span>
          <a-input
            allowClear
            class="w300 ml10"
            placeholder="请输入开户行名称"
            v-model="addEditParams.bank"
          />
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import {
  bankCardImportTemplate,
  getBankCardList,
  deleteBankCardList,
  addBankCardList,
  updateBankCardList,
  importSysBankCard
} from '../api/api'
import { validateIdCard } from '@/assets/js/auth.js'
import staticData from '../staticData/staticData'
export default {
  data() {
    return {
      confirmLoading: false,
      importData: false, //导入错误信息
      columns: staticData.bankCardColumns,
      visibleBatchImport: false, // 批量导入弹窗
      visible2: false,
      visibleAddEdit: false, // 列表 新增编辑弹窗
      addEditParams: {}, // 新增编辑弹窗 接口参数
      addEditTitle: '', // 新增编辑弹窗 标题
      bankCardList: [], // 银行卡 列表
      bankCardLoading: false, // 列表 加载
      timeHorizon: [], //入职时间范围
      queryForm: {}, //搜索项
      organizationIds: [], // 选中的部门
      excelHeader: [], //导出对应字段value
      excelHeaderKey: [], //导出对应标题label
      replaceFields: {
        key: 'id',
        value: 'id',
        children: 'treeList',
        title: 'organizationName'
      },
      // 分页器 部分
      paginationParams: {
        page: 1,
        total: 0,
        size: 10
      },

      importList: [],
      bfileList: [],
      headers: {
        Authentication: localStorage.getItem('token')
      }
    }
  },
  created() {
    // 默认查询全部
    this.getBankCardListFn()
  },
  computed: {},
  methods: {
    cancel() {
      //取消
      this.queryForm = {}
    },
    //搜索
    subMit() {
      this.paginationParams.page = 1
      this.getBankCardListFn()
    },
    // 获取列表
    getBankCardListFn() {
      let params = this.queryForm
      params.page = this.paginationParams.page
      params.size = this.paginationParams.size
      this.bankCardLoading = true
      getBankCardList(params).then((res) => {
        const { data, code, count } = res.data
        this.bankCardLoading = false
        this.paginationParams.total = count
        if (code === 0) {
          this.bankCardList = data
        } else {
          this.bankCardList = []
        }
      })
    },
    add(index, data) {
      this.addEditIndex = index
      if (index === '0') {
        this.addEditParams = {} //如果是新增 先置空表单
        this.addEditTitle = '银行卡号新增'
      } else {
        this.addEditParams = data
        this.addEditTitle = '银行卡号修改'
      }
      this.visibleAddEdit = true
    },
    showModal(type) {
      if (type == 1) {
        this.visibleBatchImport = true
      } else if (type == 2) {
        this.visible2 = true
      }
    },
    // 下载魔板
    downTemplate() {
      //下载模板
      bankCardImportTemplate().then((response) => {
        let blob = new Blob([response.data], {
          type: 'application/vnd.ms-excel'
        })
        let fileName = '银行卡模板.xlsx'
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName)
        } else {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = fileName
          link.click()
          //释放内存
          window.URL.revokeObjectURL(link.href)
        }
      })
    },
    beforeUpload(file, fileList) {
      return false
    },
    // 上传文件
    uploading(file) {
      this.$message.loading('导入中···', 0)
      let formDataChildren = new FormData()
      formDataChildren.append('file', file.file)
      importSysBankCard(formDataChildren).then((res) => {
        if (res.data.code == 0) {
          this.$message.destroy()
          this.visibleBatchImport = false
          this.$success({
            title: '导入成功',
            // JSX support
            okText: '确定',
            content: res.data.msg,
            onOk: () => {
              this.paginationParams.page = 1
              this.getBankCardListFn()
            }
          })
        } else if (res.data.code == 2) {
          //
          this.$message.destroy()
          this.importList = res.data.data
          this.importData = true
        }
      })
    },
    importDataOk() {
      this.importData = false
    },
    // 分页器改变事件
    pageChange(pageNumber) {
      this.paginationParams.page = pageNumber
      this.getBankCardListFn()
    },
    // 身份证效验
    idCardNumberBlur() {
      if (!this.queryForm.idCardNumber) return
      let n = validateIdCard(this.queryForm.idCardNumber)
      if (!n) {
        this.queryForm.idCardNumber = ''
        this.$message.error('身份证号格式错误')
      }
    },
    // 确认新增 编辑
    handleAddEditOk() {
      if (this.addEditIndex === '0') {
        // 新增
        let params = this.addEditParams
        addBankCardList(params).then((res) => {
          const { code } = res.data
          if (code === 0) {
            this.$message.success('添加成功')
            this.getBankCardListFn() // 重新加载列表
            this.visibleAddEdit = false // 关闭弹窗
            this.addEditParams = {} // 清空添加/修改弹窗表单数据
          }
        })
      } else {
        // 修改
        let params = this.addEditParams
        updateBankCardList(params).then((res) => {
          const { code } = res.data
          if (code === 0) {
            this.$message.success('修改成功')
            this.getBankCardListFn() // 重新加载列表
            this.visibleAddEdit = false // 关闭弹窗
            this.addEditParams = {} // 清空添加/修改弹窗表单数据
          }
        })
      }
    },
    // 删除
    deleteRow(id) {
      this.$confirm({
        title: '确定删除吗?',
        okType: 'danger',
        onOk: () => {
          deleteBankCardList(id).then((res) => {
            const { code } = res.data
            if (code === 0) {
              this.$message.success('删除成功')
              this.getBankCardListFn() // 重新加载列表
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.query {
  margin: 24px 16px;
  .query-top {
    padding: 0 24px;
    background: #fff;
    .query-top-item {
      height: 66px;
      // border-bottom: rgba(229, 229, 229, 1) 1px solid;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .query-top-lable {
        margin-right: 10px;
        width: 75px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        text-align: right;
      }
    }
    .query-top-item2 {
      //   height: 66px;
      border-bottom: rgba(229, 229, 229, 1) 1px solid;

      .query-top-select {
        width: calc(100% - 200px);
        .query-cont {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .query-view {
            display: flex;
            align-items: center;
            justify-content: center;
            .query-view-lable {
              width: 75px;
              color: rgba(0, 0, 0, 0.65);
              font-size: 14px;
              line-height: 22px;
              text-align: right;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .query-content {
    padding: 24px;
    background: #fff;
  }
}

.xlsx {
  width: 204px;
  height: 22px;
  margin: 32px 25px;
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.xlsx-btn {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.operating-day {
  margin-left: 38px;
}
.import-scrollY {
  overflow-y: scroll;
  max-height: calc(100vh - 500px);
}
.operating-checkbox {
  margin: 20px 10px;
  .ant-checkbox-group-item {
    margin-bottom: 8px;
  }
}

// 弹窗
.item-formCont {
  display: flex;
  align-items: center;
  .leftTitle {
    display: block;
    width: 85px;
    font-size: 14px;
    color: rgba(113, 113, 113, 1);
    font-weight: 500;
  }
  .textContent {
    font-size: 18px;
    margin-left: 20px;
    color: rgba(113, 113, 113, 1);
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PersonnelManagement/BankCard/index.vue